export function buildCpsFilterQuery(filters) {
    const queries = [];
    for (const [key, values] of Object.entries(filters)) {
        if (values.length > 0) {
            if (key === 'divisions') {
                queries.push(`filter=divisions(${values.map((v) => `${v.toUpperCase()} DIVISION`).join(',')})`);
            }
            else if (key === 'brandName') {
                queries.push(`filter=brandName(${values.join(',')})`);
            }
            else if (key === 'fieldsOfPlay') {
                queries.push(`filter=fieldsOfPlay(${values.join(',')})`);
            }
        }
    }
    return queries.join('&');
}
